import React from 'react'
import company1 from '../../assets/trusted1.jpg'
import company2 from '../../assets/trusted2.jpg'
import company3 from '../../assets/trusted3.jpg'
import './TrustedBy.css'
import { Grid } from '@mui/material'
const TrustedBy = () => {
    return (
        <div className="trust-container">
            <div className="trust-title">
                <span>Trusted-By</span>
            </div>
            <Grid container className='trust-cards' rowSpacing={5} columnSpacing={{ md: 1, sm: 3 }}>
                <Grid className='trust-card' style={{display:'flex',justifyContent:'flex-end'}} item md={5}>
                    <div className="trust-img">
                        <img src={company1} alt="" />
                    </div>
                </Grid>
                <Grid className='trust-card' item md={2} style={{display:'flex',justifyContent:'center'}}>
                    <div className="trust-img">
                        <img src={company2} alt="" />
                    </div>
                </Grid>
                <Grid className='trust-card' item md={5} style={{display:'flex',justifyContent:'flex-start'}}>
                    <div className="trust-img">
                        <img src={company3} alt="" />
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default TrustedBy